










































































































































import Vue from "vue";
import TableComplement from "@/components/Table/Complement/TableComplement.vue";
import DeviceData_ from "@/components/Table/Device/DeviceData.vue";
import DeviceFilter from "@/components/Table/Device/DeviceFilter.vue";
import CardTitle from "@/components/Text/Card/CardTitle.vue";
import { DeviceFilterName, DeviceFilters, IMapDataDefinition, StateEnum, typeOfDisplay, UserRole } from "@/types/types";
import { store } from "@/store/store";
import { Device, Device_ } from "@/store/modules/Device/interface";
import DescriptionBar from "@/components/Bar/DescriptionBar.vue";
import DisponibilityCard from "@/components/Page/Device/DisponibilityCard.vue";
import AgenceCard from "@/components/Page/Device/AgenceCard.vue";
import MabBar from "@/components/Map/MapBar.vue";
import StandartCard from "@/components/Card/StandartCard/StandartCard.vue";
import DeviceCreateModal from "@/components/Modal/Device/DeviceCreateModal.vue";
import ToastNotification, { Toast, ToastType } from "@/components/Modal/Toast/Toast.vue";
import DeviceStateCard from "@/components/Page/Device/DeviceStateCard.vue";
import LastModificationDate from "@/components/Page/Device/LastModificationDate.vue";
import DeviceMultipleUpdateModal from "@/components/Modal/Device/DeviceMultipleUpdateModal.vue";
import DeviceCreateMultipleModal from "@/components/Modal/Device/DeviceCreateMultipleModal.vue";
import DeviceAssignationModal from "@/components/Modal/Device/DeviceAssignationModal.vue";
import Utils from "@/utils/utils";
import Csv from "@/plugins/csv";
import DeviceDeleteModal from "@/components/Modal/Device/DeviceDeleteModal.vue";
import DeviceDeleteMultipleModal from "@/components/Modal/Device/DeviceMultipleDeleteModal.vue";

interface DeviceData {
  selected: Array<string>;
  filter_should_be_displayed: boolean;
  filters: DeviceFilters;
  map_should_be_displayed: boolean;
  description_should_be_displayed: boolean;
  should_display_toast: boolean;
  should_display_create_modal: boolean;
  toast: Toast;
  device: Device | null;
  interval_description_panel: number | null;
  should_display_multiple_update_modal: boolean;
  should_display_multiple_create_modal: boolean;
  should_display_device_assignation_modal: boolean;
  should_display_delete_modal: boolean;
  should_display_delete_multiple_modal: boolean;
  data_display: typeOfDisplay;
  sort_by: string | undefined;
  sort: string | null;
}

export default Vue.extend({
  name: "Device",
  components: {
    TableComplement,
    DeviceData_,
    CardTitle,
    DeviceFilter,
    DescriptionBar,
    DisponibilityCard,
    AgenceCard,
    MabBar,
    StandartCard,
    ToastNotification,
    DeviceCreateModal,
    DeviceStateCard,
    LastModificationDate,
    DeviceMultipleUpdateModal,
    DeviceCreateMultipleModal,
    DeviceAssignationModal,
    DeviceDeleteModal,
    DeviceDeleteMultipleModal
  },
  created(): void {
    this.parse_url();
  },
  data(): DeviceData {
    return {
      selected: [],
      filter_should_be_displayed: false,
      description_should_be_displayed: false,
      filters: {
        disponibility: "",
        material_name: "",
        category: "",
        state: "",
        agence: "",
        updated: "",
        campaign: ""
      },
      map_should_be_displayed: false,
      should_display_toast: false,
      should_display_create_modal: false,
      toast: { type: ToastType.INFO, title: "", content: "" },
      device: null,
      interval_description_panel: null,
      should_display_multiple_update_modal: false,
      should_display_multiple_create_modal: false,
      should_display_device_assignation_modal: false,
      should_display_delete_modal: false,
      should_display_delete_multiple_modal: false,
      data_display: typeOfDisplay.TABLE,
      sort_by: undefined,
      sort: null
    };
  },
  methods: {
    parse_url(): void {
      const params = Utils.getUrlParameters();
      if (params.get("page")) {
        this.data_display =
          params.get("page") === typeOfDisplay.CARD || params.get("page") === typeOfDisplay.GRAPH
            ? typeOfDisplay.CARD
            : typeOfDisplay.TABLE;
      }
      if (params.get("filter") && params.get("filter") !== null) {
        this.filters = JSON.parse(params.get("filter") as string);
      }
      if (
        params.get("sort") &&
        params.get("sort") !== "undefined" &&
        params.get("sort") !== null &&
        params.get("sort") !== "null"
      ) {
        this.sort_by = "material_name";
        this.sort = JSON.parse(params.get("sort") as string);
      }
    },
    sorted_filter(sort_: string): void {
      if (sort_ === "" || sort_ === null || sort_ === undefined) {
        this.sort_by = undefined;
        this.sort = null;
      } else {
        this.sort_by = "material_name";
        this.sort = sort_;
      }
      this.changeUrl("sort", JSON.stringify(this.sort));
    },
    /* These methods are here to handle all the change of the filter */
    onFilterChange(filter: { type: DeviceFilterName; value: string }): void {
      this.filters[filter.type] = filter.value;
      this.changeUrl("filter", JSON.stringify(this.filters));
    },
    changeUrl(param_name: string, param_content: string): void {
      const params = Utils.getUrlParameters();
      params.set(param_name, param_content);
      history.pushState(null, "", "?" + params.toString());
    },
    clearFilter(): void {
      this.filters = {
        disponibility: "",
        material_name: "",
        category: "",
        state: "",
        agence: "",
        updated: "",
        campaign: ""
      };
      this.changeUrl("filter", JSON.stringify(this.filters));
    },
    /****************************************************************/
    clearSelected(): void {
      this.selected = [];
    },
    onSelectChange(_ids: Array<string>): void {
      this.selected = _ids;
    },
    shouldDisplayFilterPanel(): void {
      this.filter_should_be_displayed = !this.filter_should_be_displayed;
    },
    shouldDisplayDescriptionPanel(item: Device): void {
      if (this.description_should_be_displayed && item._id === this?.device?._id)
        return this.shouldCloseDescriptionPanel();
      else if (this.description_should_be_displayed && item._id !== this?.device?._id) {
        this.description_should_be_displayed = false;
        if (!this.interval_description_panel) window.clearInterval(this.interval_description_panel as number);
        this.interval_description_panel = window.setTimeout(() => this.shouldDisplayDescriptionPanel(item), 500);
      } else {
        this.device = item;
        this.description_should_be_displayed = true;
      }
    },
    shouldCloseDescriptionPanel(): void {
      this.description_should_be_displayed = false;
    },
    mapDisplayToggle(): void {
      this.map_should_be_displayed = !this.map_should_be_displayed;
    },
    shouldDisplayCreateModal(_id: string | null = null): void {
      if (_id) this.device = { ...store.getters.DEVICE_BY_ID[_id] };
      this.should_display_create_modal = true;
    },
    onClose(): void {
      this.should_display_create_modal = false;
      this.should_display_multiple_update_modal = false;
      this.should_display_multiple_create_modal = false;
      this.should_display_device_assignation_modal = false;
      this.should_display_delete_modal = false;
      this.should_display_delete_multiple_modal = false;
      this.device = null;
    },
    /* These methods are here to handle the display of the toast notification modal */
    shouldDisplayToastNotification(toast_data: Toast): void {
      this.toast = toast_data;
      this.should_display_toast = true;
      setTimeout(this.shouldCloseToastNotification, 2000);
    },
    shouldCloseToastNotification(): void {
      this.should_display_toast = false;
    },
    /****************************************************************/
    shouldDisplayMultipleUpdateModal(): void {
      this.should_display_multiple_update_modal = true;
    },
    shouldDisplayDeleteModal(_id: string): void {
      this.device = { ...store.getters.DEVICE_BY_ID[_id] };
      this.should_display_delete_modal = true;
    },
    shouldDisplayDeleteMultipleModal(): void {
      this.should_display_delete_multiple_modal = true;
    },
    shouldDisplayMultipleCreateModal(): void {
      this.should_display_multiple_create_modal = true;
    },
    shouldDisplayAssignationModal(_id: string): void {
      this.device = { ...store.getters.DEVICE_BY_ID[_id] };
      this.should_display_device_assignation_modal = true;
    },
    downloadCsv(): void {
      const selected = this.selected.length === 0 ? store.getters.DEVICE_ALL_ID : this.selected;
      const headers = [
        "material_name",
        "category",
        "agence",
        "state",
        "comment",
        "disponibility",
        "specifity",
        "version_ihm",
        "version_os",
        "sd",
        "infrared"
      ];
      const content = selected.map((device_id: string) => {
        let device: Device_ = { ...store.getters.DEVICE_BY_ID[device_id] };
        device.disponibility = store.getters.STATE_BY_ID[device.state].name === StateEnum.RESERVE_DISP;
        device.state = store.getters.STATE_BY_ID[device.state].name;
        device.category = store.getters.CATEGORY_BY_ID[device.category].name;
        device.agence = store.getters.AGENCE_BY_ID[device.agence].name;
        return device;
      });
      const blob = Utils.createCsvBlob(new Csv().FromObjToCsv<Device_>(headers, content));
      Utils.createAndClickHiddenInput(URL.createObjectURL(blob), "appareils.csv");
    },
    modifyDataDisplay(): void {
      this.data_display = this.data_display === typeOfDisplay.TABLE ? typeOfDisplay.CARD : typeOfDisplay.TABLE;
      this.data_display === typeOfDisplay.TABLE
        ? this.changeUrl("page", typeOfDisplay.TABLE)
        : this.changeUrl("page", typeOfDisplay.CARD);
    }
  },
  computed: {
    transformDataForMap(): Array<IMapDataDefinition> {
      let selected = this.selected;
      if (selected.length === 0) selected = [];
      const data = selected.map((device_id) => {
        const device = store.getters.DEVICE_BY_ID[device_id];
        let data_definition: IMapDataDefinition = { name: "", comment: "", location: { longitude: 0, latitude: 0 } };
        data_definition.name = `${device.material_name} : ${store.getters.CATEGORY_BY_ID[device.category].name}`;
        data_definition.comment = device.comment as string;
        data_definition.location = device.location;
        return data_definition;
      });
      return data.filter(
        (d) =>
          d.location?.longitude !== 0 && d.location?.longitude && d.location?.latitude !== 0 && d.location?.latitude
      );
    },
    isUserAdmin(): boolean {
      return (
        store.getters.ROLE_BY_ID[store.getters.LOGGED_USER?.role as string].name.toUpperCase() ===
        UserRole.ADMINISTRATOR
      );
    }
  },
  watch: {
    $route: {
      handler(): void {
        this.parse_url();
      }
    }
  }
});
